import React from 'react'
import { connect } from 'react-redux'
import { getListItems, changeListItem, nullDate } from 'tyan/public/utility'
import { hasChangedValues, getFormValue, changeItemsValue } from 'tyan/public/utility/formValues'
import RequisitionDiv from 'tyan/menus/PurchaseManageMent/RequisitionDiv'
// import MaterialSelect from './MaterialSelect'
class RequisitionBatchDiv extends React.Component {
    state = {
        ids: this.props.ids || []
    }

    componentDidMount = () => {
        this.handlerInitValue()
    }

    handlerInitValue = () => {
        const { ids } = this.state
        Tyan.doPostEvent({
            event: 'GetRequisitionBatch',
            data: { ids },
            onEnd: ({ errorMessage, initValues基本信息, optionsParas }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    this.setState({ id, initValues基本信息, changedValues基本信息: {}, optionsParas })
                }
            }
        })
    }

    handlerClose = () => {
        const { onClose } = this.props
        onClose && onClose()
    }

    fieldset基本信息 = () => {
        const { list } = getListItems(this, '基本信息', '采购单号')
        const p = { margin: '5px 5px 5px 5px', minWidth: 1, _full: true, flex: 1}
        return [
            {
                _group: ``, name: `采购单号`, minWidth: '90%',   items: [
                    {
                        _group: ``, minWidth: '95%', items: [
                            { _label: '采购单号', ...p, },
                            { _label: '供应商名称', ...p, },
                            { _label: '金额', ...p, },
                            {
                                _buttons: [
                                    { _button: '', icon: '', ui: '', margin: 0, disabled: true  }
                                ], width: '101px', margin: 0
                            }
                        ]
                    }
                ].concat(list && list.map(({ id }) => {
                    const _list = { listName: '采购单号', id }
                    return {
                        _group: '', minWidth: '95%', list: _list, items: [
                            { _text: '', name: '采购单号', ...p, disabled: true },
                            { _text: '', name: '供应商名称', ...p, disabled: true },
                            { _float: '', name: '金额', ...p, textAlign: 'left', disabled: true },
                            {
                                _buttons: [
                                    { _button: '查看', icon: '', ui: '', margin: 0, handler: () => Tyan.pubForm.showDialog('请购信息', props => <RequisitionDiv {...props} id={id} />) }
                                ], width: '101px', margin: 0
                            }
                        ]
                    }
                }))
            },
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body, readOnly } = this.props
        const { initValues基本信息 } = this.state
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        return <Body data={this} maxWidth="1200"
            controls={[
                { _button: '关闭', icon: 'close', handler: this.handlerClose }
            ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息() },
                    
                ]}
        />
    }
}

export default connect()(RequisitionBatchDiv)